export const AlertResolvedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    style={{ flexShrink: 0, display: 'block' }}
  >
    <path
      d="M11.6667 23.3333C14.7609 23.3333 17.7283 22.1042 19.9162 19.9162C22.1042 17.7283 23.3333 14.7609 23.3333 11.6667C23.3333 8.57247 22.1042 5.60501 19.9162 3.41709C17.7283 1.22916 14.7609 0 11.6667 0C8.57247 0 5.60501 1.22916 3.41709 3.41709C1.22916 5.60501 0 8.57247 0 11.6667C0 14.7609 1.22916 17.7283 3.41709 19.9162C5.60501 22.1042 8.57247 23.3333 11.6667 23.3333ZM16.8164 9.52474L10.9831 15.3581L10.2083 16.1328L9.43359 15.3581L6.51693 12.4414L5.74219 11.6667L7.29167 10.1217L8.06641 10.8965L10.2083 13.0384L15.2669 7.97526L16.0417 7.20052L17.5866 8.75L16.8118 9.52474H16.8164Z"
      fill="#00A67F"
    />
  </svg>
);
